import { observer } from 'mobx-react-lite'
import React from 'react'
import { Route, Routes } from 'react-router-dom'

export default observer(function CampaignInfluencerSidebarPageRoutes({
  auth,
  TagsComponent,
  ProfileComponent,
  PMThreadComponent,
  ClientThreadComponent,
  AuthenticationComponent,
  showTags = false,
  showPmThread = false,
  showAuthentication = false,
}) {
  return (
    <div className='h-full flex flex-col'>
      <Routes>
        {showTags && TagsComponent && <Route path="tags" element={<TagsComponent auth={auth} />} />}
        {ProfileComponent && <Route path="profile" element={<ProfileComponent auth={auth} />} />}
        {showPmThread && PMThreadComponent && <Route path="pm_thread" element={<PMThreadComponent auth={auth} />} />}
        {ClientThreadComponent && <Route path="client_thread" element={<ClientThreadComponent auth={auth} />} />}
        {showAuthentication && AuthenticationComponent && <Route path="authentication/:authentication_id/*" element={<AuthenticationComponent />} />}
      </Routes>
    </div>
  )
})
